module.exports = __webpack_public_path__ + "media/components/assets/img/icons/booking-5a0a4483df4068cc48931cda29a43622.svg";